import { types } from "./actionTypes";
export const freightsMaster = (filters,searchFilter,callback) => ({
  type: types.FREIGHTS_MASTER,
  filters,
  searchFilter,
  callback,
});


